// This file is auto-generated by @hey-api/openapi-ts

export {
  apiSchemaRetrieve,
  authenticationFetchBeaconRoles,
  authenticationPermissionGroupAssignmentsCreate,
  authenticationPermissionGroupAssignmentsDestroy,
  authenticationPermissionGroupAssignmentsRetrieve,
  authenticationPermissionGroupAssignmentsSearchCreate,
  authenticationPermissionGroupAssignmentsUpdate,
  authenticationPermissionGroupsCreate,
  authenticationPermissionGroupsDestroy,
  authenticationPermissionGroupsRetrieve,
  authenticationPermissionGroupsSearchCreate,
  authenticationPermissionGroupsUpdate,
  authenticationRoleAssignmentsCreate,
  authenticationRoleAssignmentsDestroy,
  authenticationRoleAssignmentsRetrieve,
  authenticationRoleAssignmentsSearchCreate,
  authenticationRolesCreate,
  authenticationRolesDestroy,
  authenticationRolesPartialUpdate,
  authenticationRolesRetrieve,
  authenticationRolesSearchCreate,
  authenticationRolesUpdate,
  backgroundTasksTasksRetrieve,
  directoutreachBetanxtVoterPolicySnapshotExportCreate,
  directoutreachPolicyAvailableList,
  directoutreachPolicyAvailableRetrieve,
  directoutreachPolicyCreate,
  directoutreachVotersBatchCreateCreate,
  directoutreachVotersCreateCreate,
  directoutreachVotersHoldingsRetrieve,
  directoutreachVotersRetrieve,
  directoutreachVotersSelectedPolicyCreate,
  directoutreachVotersSelectedPolicyRetrieve,
  directvotingBallotsCastVoteCreate,
  directvotingBallotsProposalsRetrieve,
  directvotingBallotsSearchCreate,
  directvotingBallotStampsRetrieve,
  directvotingBallotStampsSearchCreate,
  directvotingBallotWorkflowItemsCreate,
  directvotingBallotWorkflowItemsDestroy,
  directvotingBallotWorkflowItemsPartialUpdate,
  directvotingBallotWorkflowItemsRetrieve,
  directvotingBallotWorkflowItemsSearchCreate,
  directvotingBeaconRuleOutputsCreate,
  directvotingBeaconRuleOutputsDestroy,
  directvotingBeaconRuleOutputsRetrieve,
  directvotingBeaconRuleOutputsSearchCreate,
  directvotingCustodyAccountGroupMembershipsCreate,
  directvotingCustodyAccountGroupMembershipsDestroy,
  directvotingCustodyAccountGroupMembershipsSearchCreate,
  directvotingCustodyAccountGroupsCreate,
  directvotingCustodyAccountGroupsDestroy,
  directvotingCustodyAccountGroupsPartialUpdate,
  directvotingCustodyAccountGroupsRetrieve,
  directvotingCustodyAccountGroupsSearchCreate,
  directvotingCustodyAccountGroupsUpdate,
  directvotingCustodyAccountTenantLinksLinkCreate,
  directvotingCustodyAccountTenantLinksList,
  directvotingCustodyAccountTenantLinksUnlinkCreate,
  directvotingCustodyAccountVotingPolicySelectionsCreate,
  directvotingCustodyAccountVotingPolicySelectionsDestroy,
  directvotingCustodyAccountVotingPolicySelectionsPartialUpdate,
  directvotingCustodyAccountVotingPolicySelectionsRetrieve,
  directvotingCustodyAccountVotingPolicySelectionsSearchCreate,
  directvotingCustodyAccountVotingPolicySelectionsUpdate,
  directvotingMeetingsAssignmentSearchCreate,
  directvotingMeetingsSearchCreate,
  directvotingRulesEngineRulesCreate,
  directvotingRulesEngineRulesDestroy,
  directvotingRulesEngineRulesListsCreate,
  directvotingRulesEngineRulesListsDestroy,
  directvotingRulesEngineRulesListsPartialUpdate,
  directvotingRulesEngineRulesListsRetrieve,
  directvotingRulesEngineRulesListsSearchCreate,
  directvotingRulesEngineRulesPartialUpdate,
  directvotingRulesEngineRulesRetrieve,
  directvotingRulesEngineRulesSearchCreate,
  directvotingWatchlistItemsBatchCreate,
  directvotingWatchlistItemsCreate,
  directvotingWatchlistItemsDestroy,
  directvotingWatchlistItemsRetrieve,
  directvotingWatchlistItemsSearchCreate,
  directvotingWatchlistsCreate,
  directvotingWatchlistsDestroy,
  directvotingWatchlistsPartialUpdate,
  directvotingWatchlistsRetrieve,
  directvotingWatchlistsSearchCreate,
  fundManagerFundManagersCreate,
  fundManagerFundManagersPoliciesCreate,
  fundManagerFundManagersPoliciesRetrieve,
  fundManagerFundManagersRetrieve,
  fundManagerFundManagersSearchCreate,
  fundManagerFundManagersUpdate,
  fundManagerFundsCreate,
  fundManagerFundsQuantificationSnapshotsCreate,
  fundManagerFundsRetrieve,
  fundManagerFundsSearchCreate,
  fundManagerFundsUpdate,
  fundManagerFundVariantsCreate,
  fundManagerFundVariantsDestroy,
  fundManagerFundVariantsRetrieve,
  fundManagerFundVariantsSearchCreate,
  fundManagerFundVariantsUpdate,
  fundManagerProvidersCreate,
  fundManagerProvidersList,
  fundManagerProvidersRetrieve,
  fundManagerProvidersUpdate,
  fundManagerPublicSecurityIdsCreate,
  fundManagerPublicSecurityIdsSearchCreate,
  fundManagerQuantificationSnapshotsSearchCreate,
  institutionalMeetingsearchList,
  issuerFiscalYearsCreate,
  issuerFiscalYearsSearchCreate,
  issuerInstrumentsCreate,
  issuerInstrumentsOutstandingSharesCreate,
  issuerInstrumentsOutstandingSharesRetrieve,
  issuerInstrumentsRetrieve,
  issuerInstrumentsSearchCreate,
  issuerInstrumentsTotalShareholderReturnCreate,
  issuerInstrumentsTotalShareholderReturnRetrieve,
  issuerIssuersCreate,
  issuerIssuersMarketCapitalisationCreate,
  issuerIssuersMarketCapitalisationRetrieve,
  issuerIssuersRetrieve,
  issuerIssuersSearchBySecurityIdsCreate,
  issuerIssuersSearchCreate,
  type Options,
  proxyIntermediaryBallotsFetchByVersionIdsCreate,
  proxyIntermediaryBallotsProxymityStaleProposalSetList,
  proxyIntermediaryBallotsSearchCreate,
  proxyIntermediaryBallotsUpsertCreate,
  proxyIntermediaryBallotsVersionsList,
  proxyIntermediaryCustodyAccountsCreate,
  proxyIntermediaryCustodyAccountsDestroy,
  proxyIntermediaryCustodyAccountsPartialUpdate,
  proxyIntermediaryCustodyAccountsRetrieve,
  proxyIntermediaryCustodyAccountsSearchCreate,
  proxyIntermediaryCustodyAccountsUpdate,
  proxyIntermediaryPiProposalCategoriesUpsertCreate,
  proxyIntermediaryProposalCategoriesAssignCreate,
  proxyIntermediaryProposalCategoriesListCreate,
  proxyIntermediaryProposalLabelsAssignCreate,
  proxyIntermediaryProposalLabelsFetchCreate,
  proxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreate,
  proxyIntermediaryProposalsCreateCreate,
  proxyIntermediaryProposalsDeleteCreate,
  proxyIntermediaryProposalsProxymityProposalSetFetchLatestCreate,
  proxyIntermediaryProposalsSearchCreate,
  proxyIntermediaryProxyedgeVotesCreateCreate,
  proxyIntermediaryProxyedgeVotesFetchLatestCreate,
  proxyIntermediaryProxyedgeVotesHardDeleteCreate,
  proxyIntermediaryProxyIntermediariesSearchCreate,
  proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreate,
  proxyIntermediaryProxyIntermediaryMeetingsCancelCreate,
  proxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreate,
  proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreate,
  proxyIntermediaryProxyIntermediaryMeetingsSearchCreate,
  proxyIntermediaryProxyIntermediaryMeetingsSecurityIdsRetrieve,
  proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreate,
  proxyIntermediaryProxyIntermediaryMeetingsUpsertCreate,
  proxyIntermediaryProxymityVotesCreateCreate,
  proxyIntermediaryProxymityVotesFetchLatestCreate,
  proxyIntermediaryVoteStatusesDeleteCreate,
  proxyIntermediaryVoteStatusesHardDeleteCreate,
  proxyIntermediaryVoteStatusesUpsertCreate,
  proxyvotingEntitlementsBreakdownCreate,
  proxyvotingEntitlementsComputeCreate,
  proxyvotingEntitlementsList,
  proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreate,
  proxyvotingFundManagerSupportedPoliciesCreate,
  proxyvotingFundManagerSupportedPoliciesDestroy,
  proxyvotingFundManagerSupportedPoliciesList,
  proxyvotingInvestorCompositionsDifferenceList,
  proxyvotingInvestorCompositionsRenderCreate,
  proxyvotingInvestorCompositionsRulesEngineRetrieve,
  proxyvotingInvestorCompositionsRulesEngineUpdate,
  proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate,
  proxyvotingMeetingballotsComputeCreate,
  proxyvotingMeetingBallotsList,
  proxyvotingMeetingBallotSourcesList,
  proxyvotingPiballotsFilterList,
  proxyvotingPiballotsInvestorsCanVoteCreate,
  proxyvotingPimeetingsFilterList,
  proxyvotingRulesEngineDefinitionsByNameDestroy,
  proxyvotingRulesEngineDefinitionsCreate,
  proxyvotingRulesEngineDefinitionsDestroy,
  proxyvotingRulesEngineDefinitionsList,
  proxyvotingRulesEngineDefinitionsNamesRetrieve,
  proxyvotingRulesEngineDefinitionsRetrieve,
  proxyvotingRulesEngineDefinitionsRulesCreate,
  proxyvotingRulesEngineDefinitionsRulesDestroy,
  proxyvotingRulesEngineDefinitionsRulesList,
  proxyvotingRulesEngineDefinitionsRulesUpdate,
  proxyvotingSviProposalOverwriteCreate,
  proxyvotingSviProposalOverwriteReasonsList,
  proxyvotingSviSubmitVoteCreate,
  tenancyTenantsCreate,
  tenancyTenantsDestroy,
  tenancyTenantsRetrieve,
  tenancyTenantsSearchCreate,
  tenancyTenantsUpdate,
  tenancyUsersCreate,
  tenancyUsersDestroy,
  tenancyUsersRetrieve,
  tenancyUsersSearchCreate,
  tenancyUsersUpdate,
  transparencyAuditEventsSearchCreate,
  transparencyExternalMeetingIdsCreate,
  transparencyExternalMeetingIdsDestroy,
  transparencyGeneralMeetingsCreate,
  transparencyGeneralMeetingsPartialUpdate,
  transparencyGeneralMeetingsRetrieve,
  transparencyGeneralMeetingsSearchCreate,
  transparencyInstrumentsCreate,
  transparencyInstrumentsDestroy,
  transparencyInstrumentsFetchMinimalCreate,
  transparencyInstrumentsRetrieve,
  transparencyInstrumentsSearchCreate,
  transparencyInstrumentsUnassociatedRetrieve,
  transparencyInstrumentsUpdate,
  transparencyOrganizationsCreate,
  transparencyOrganizationsDestroy,
  transparencyOrganizationsGeneralMeetingsProposalsCreate,
  transparencyOrganizationsGeneralMeetingsProposalsPartialUpdate,
  transparencyOrganizationsGeneralMeetingsProposalsRetrieve,
  transparencyOrganizationsGeneralMeetingsProposalsSearchCreate,
  transparencyOrganizationsGeneralMeetingsProposalsUpdate,
  transparencyOrganizationsGetByIdentifierCreate,
  transparencyOrganizationsIsinsToNamesCreate,
  transparencyOrganizationsLogoCreate,
  transparencyOrganizationsPartialUpdate,
  transparencyOrganizationsRetrieve,
  transparencyOrganizationsSearchCreate,
  transparencyOrganizationsUpdate,
  transparencyProposalsClassificationCodesRetrieve,
  transparencyProposalsCountCreate,
  transparencyProposalsFetchCreate,
  transparencyProposalsFetchNamesFromIdsCreate,
  transparencyProposalsSecClassificationCodesRetrieve,
  transparencyPublicSecurityIdsSearchCreate,
  votingOperationsPiballotsFilterList,
  votingOperationsPimeetingsFilterList,
  votingPolicyProposalSetRecommendationCoverageDetailRetrieve,
  votingPolicyProposalSetRecommendationCoverageSearchCreate,
  votingPolicyProviderVotingRecommendationsCreate,
  votingPolicyProviderVotingRecommendationsDestroy,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve,
  votingPolicyProviderVotingRecommendationsMatchCreate,
  votingPolicyProviderVotingRecommendationsSearchCreate,
  votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdate,
  votingPolicyProxyIntermediaryVotingRecommendationsCreate,
  votingPolicyProxyIntermediaryVotingRecommendationsDestroy,
  votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreate,
  votingPolicyProxyIntermediaryVotingRecommendationsSearchCreate,
  votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieve,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreate,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreate,
  votingPolicyVotingPoliciesCreate,
  votingPolicyVotingPoliciesDestroy,
  votingPolicyVotingPoliciesDocumentsCreate,
  votingPolicyVotingPoliciesDocumentsList,
  votingPolicyVotingPoliciesDocumentsPartialUpdate,
  votingPolicyVotingPoliciesDocumentsRetrieve,
  votingPolicyVotingPoliciesPartialUpdate,
  votingPolicyVotingPoliciesRetrieve,
  votingPolicyVotingPoliciesSearchCreate,
  votingPolicyVotingPoliciesVotingRecommendationsCreate,
  votingPolicyVotingPoliciesVotingRecommendationsDestroy,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieve,
  votingPolicyVotingPoliciesVotingRecommendationsSearchCreate,
  votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreate,
  votingPolicyVotingRecommendationConfidenceScoresUpdate,
} from './sdk.gen'
export {
  type ApiSchemaRetrieveData,
  type ApiSchemaRetrieveResponse,
  type ApiSchemaRetrieveResponses,
  AssetClassEnum,
  type AssignProposalCategoryRequest,
  type AssignProposalCategoryResponse,
  type AssignProposalLabelRequest,
  type AssignProposalLabelResponse,
  type AuditEvent,
  type AuditEventSearchRequestRequest,
  type AuthenticationFetchBeaconRolesData,
  type AuthenticationFetchBeaconRolesErrors,
  type AuthenticationFetchBeaconRolesResponse,
  type AuthenticationFetchBeaconRolesResponses,
  type AuthenticationPermissionGroupAssignmentsCreateData,
  type AuthenticationPermissionGroupAssignmentsCreateErrors,
  type AuthenticationPermissionGroupAssignmentsCreateResponse,
  type AuthenticationPermissionGroupAssignmentsCreateResponses,
  type AuthenticationPermissionGroupAssignmentsDestroyData,
  type AuthenticationPermissionGroupAssignmentsDestroyErrors,
  type AuthenticationPermissionGroupAssignmentsDestroyResponse,
  type AuthenticationPermissionGroupAssignmentsDestroyResponses,
  type AuthenticationPermissionGroupAssignmentsRetrieveData,
  type AuthenticationPermissionGroupAssignmentsRetrieveErrors,
  type AuthenticationPermissionGroupAssignmentsRetrieveResponse,
  type AuthenticationPermissionGroupAssignmentsRetrieveResponses,
  type AuthenticationPermissionGroupAssignmentsSearchCreateData,
  type AuthenticationPermissionGroupAssignmentsSearchCreateErrors,
  type AuthenticationPermissionGroupAssignmentsSearchCreateResponse,
  type AuthenticationPermissionGroupAssignmentsSearchCreateResponses,
  type AuthenticationPermissionGroupAssignmentsUpdateData,
  type AuthenticationPermissionGroupAssignmentsUpdateErrors,
  type AuthenticationPermissionGroupAssignmentsUpdateResponse,
  type AuthenticationPermissionGroupAssignmentsUpdateResponses,
  type AuthenticationPermissionGroupsCreateData,
  type AuthenticationPermissionGroupsCreateErrors,
  type AuthenticationPermissionGroupsCreateResponse,
  type AuthenticationPermissionGroupsCreateResponses,
  type AuthenticationPermissionGroupsDestroyData,
  type AuthenticationPermissionGroupsDestroyErrors,
  type AuthenticationPermissionGroupsDestroyResponse,
  type AuthenticationPermissionGroupsDestroyResponses,
  type AuthenticationPermissionGroupsRetrieveData,
  type AuthenticationPermissionGroupsRetrieveErrors,
  type AuthenticationPermissionGroupsRetrieveResponse,
  type AuthenticationPermissionGroupsRetrieveResponses,
  type AuthenticationPermissionGroupsSearchCreateData,
  type AuthenticationPermissionGroupsSearchCreateErrors,
  type AuthenticationPermissionGroupsSearchCreateResponse,
  type AuthenticationPermissionGroupsSearchCreateResponses,
  type AuthenticationPermissionGroupsUpdateData,
  type AuthenticationPermissionGroupsUpdateErrors,
  type AuthenticationPermissionGroupsUpdateResponse,
  type AuthenticationPermissionGroupsUpdateResponses,
  type AuthenticationRoleAssignmentsCreateData,
  type AuthenticationRoleAssignmentsCreateErrors,
  type AuthenticationRoleAssignmentsCreateResponse,
  type AuthenticationRoleAssignmentsCreateResponses,
  type AuthenticationRoleAssignmentsDestroyData,
  type AuthenticationRoleAssignmentsDestroyErrors,
  type AuthenticationRoleAssignmentsDestroyResponse,
  type AuthenticationRoleAssignmentsDestroyResponses,
  type AuthenticationRoleAssignmentsRetrieveData,
  type AuthenticationRoleAssignmentsRetrieveErrors,
  type AuthenticationRoleAssignmentsRetrieveResponse,
  type AuthenticationRoleAssignmentsRetrieveResponses,
  type AuthenticationRoleAssignmentsSearchCreateData,
  type AuthenticationRoleAssignmentsSearchCreateErrors,
  type AuthenticationRoleAssignmentsSearchCreateResponse,
  type AuthenticationRoleAssignmentsSearchCreateResponses,
  type AuthenticationRolesCreateData,
  type AuthenticationRolesCreateErrors,
  type AuthenticationRolesCreateResponse,
  type AuthenticationRolesCreateResponses,
  type AuthenticationRolesDestroyData,
  type AuthenticationRolesDestroyErrors,
  type AuthenticationRolesDestroyResponse,
  type AuthenticationRolesDestroyResponses,
  type AuthenticationRolesPartialUpdateData,
  type AuthenticationRolesPartialUpdateErrors,
  type AuthenticationRolesPartialUpdateResponse,
  type AuthenticationRolesPartialUpdateResponses,
  type AuthenticationRolesRetrieveData,
  type AuthenticationRolesRetrieveErrors,
  type AuthenticationRolesRetrieveResponse,
  type AuthenticationRolesRetrieveResponses,
  type AuthenticationRolesSearchCreateData,
  type AuthenticationRolesSearchCreateErrors,
  type AuthenticationRolesSearchCreateResponse,
  type AuthenticationRolesSearchCreateResponses,
  type AuthenticationRolesUpdateData,
  type AuthenticationRolesUpdateErrors,
  type AuthenticationRolesUpdateResponse,
  type AuthenticationRolesUpdateResponses,
  AvailableToInvestorTypeEnum,
  type BackgroundTasksTasksRetrieveData,
  type BackgroundTasksTasksRetrieveErrors,
  type BackgroundTasksTasksRetrieveResponse,
  type BackgroundTasksTasksRetrieveResponses,
  type Ballot,
  BallotCancelledFilterEnum,
  type BallotEntitlement,
  type BallotEntitlementWritable,
  type BallotInvestorsCanVote,
  type BallotListResponse,
  type BallotProposal,
  type BallotProposalsResponse,
  type BallotProposalsResponseWritable,
  type BallotProposalVotingInstruction,
  type BallotProposalWritable,
  type BallotStampSearchRequestRequest,
  BallotStatusEnum,
  type BallotUpsertRequest,
  type BatchIsinsToOrganizationNamesRequestRequest,
  type BatchIsinsToOrganizationNamesResponse,
  type BatchVoterWithHoldingsInputRequest,
  type BatchVoterWithHoldingsResponse,
  type BatchVoterWithHoldingsResponseWritable,
  BeaconReferStatusEnum,
  BeaconRoleEnum,
  type BeaconRoles,
  BeaconVoteOutcomeEnum,
  BioSourceEnum,
  type BreakdownResponse,
  type CastVoteRequestRequest,
  type CastVoteResponse,
  type CastVoteResponseWritable,
  type ClientOptions,
  type ComponentDiff,
  type ComponentDiffRequest,
  ComponentDiffStatusEnum,
  type CompositionDifferenceResponse,
  ComputeBreakdownRequestInvestorTypeEnum,
  type ComputeBreakdownRequestRequest,
  type CreateProposalRequest,
  type CreateProposalsRequest,
  type CreateProposalsResponse,
  type CreateProposalsResponseWritable,
  CurrentlyVotableFilterEnum,
  type CustodianAccountReference,
  type CustodianAccountReferenceRequest,
  type CustodyAccount,
  type CustodyAccountGroup,
  type CustodyAccountGroupMembership,
  type CustodyAccountGroupMembershipRequest,
  type CustodyAccountGroupMembershipSearchRequestRequest,
  type CustodyAccountGroupMembershipWritable,
  type CustodyAccountGroupRequest,
  type CustodyAccountGroupSearchRequestRequest,
  type CustodyAccountGroupWritable,
  type CustodyAccountRequest,
  type CustodyAccountSearchRequestRequest,
  type CustodyAccountTenantLink,
  type CustodyAccountTenantLinkRequestRequest,
  type CustodyAccountTenantLinkUnlinkRequestRequest,
  type CustodyAccountTenantLinkWritable,
  type CustodyAccountVotingPolicySelection,
  type CustodyAccountVotingPolicySelectionRequest,
  type CustodyAccountVotingPolicySelectionSearchRequestRequest,
  type CustodyAccountVotingPolicySelectionWritable,
  type CustodyAccountWritable,
  type Deadlines,
  DecisionEnum,
  type DeleteProposalSetRequest,
  DiffFormatEnum,
  DirectionEnum,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  type DirectoutreachPolicyAvailableListData,
  type DirectoutreachPolicyAvailableListResponse,
  type DirectoutreachPolicyAvailableListResponses,
  type DirectoutreachPolicyAvailableRetrieveData,
  type DirectoutreachPolicyAvailableRetrieveResponse,
  type DirectoutreachPolicyAvailableRetrieveResponses,
  type DirectoutreachPolicyCreateData,
  type DirectoutreachPolicyCreateResponse,
  type DirectoutreachPolicyCreateResponses,
  type DirectoutreachVotersBatchCreateCreateData,
  type DirectoutreachVotersBatchCreateCreateErrors,
  type DirectoutreachVotersBatchCreateCreateResponse,
  type DirectoutreachVotersBatchCreateCreateResponses,
  type DirectoutreachVotersCreateCreateData,
  type DirectoutreachVotersCreateCreateResponse,
  type DirectoutreachVotersCreateCreateResponses,
  type DirectoutreachVotersHoldingsRetrieveData,
  type DirectoutreachVotersHoldingsRetrieveErrors,
  type DirectoutreachVotersHoldingsRetrieveResponse,
  type DirectoutreachVotersHoldingsRetrieveResponses,
  type DirectoutreachVotersRetrieveData,
  type DirectoutreachVotersRetrieveErrors,
  type DirectoutreachVotersRetrieveResponse,
  type DirectoutreachVotersRetrieveResponses,
  type DirectoutreachVotersSelectedPolicyCreateData,
  type DirectoutreachVotersSelectedPolicyCreateErrors,
  type DirectoutreachVotersSelectedPolicyCreateResponse,
  type DirectoutreachVotersSelectedPolicyCreateResponses,
  type DirectoutreachVotersSelectedPolicyRetrieveData,
  type DirectoutreachVotersSelectedPolicyRetrieveErrors,
  type DirectoutreachVotersSelectedPolicyRetrieveResponse,
  type DirectoutreachVotersSelectedPolicyRetrieveResponses,
  type DirectVoteInstruction,
  type DirectvotingBallotsCastVoteCreateData,
  type DirectvotingBallotsCastVoteCreateErrors,
  type DirectvotingBallotsCastVoteCreateResponse,
  type DirectvotingBallotsCastVoteCreateResponses,
  type DirectvotingBallotsProposalsRetrieveData,
  type DirectvotingBallotsProposalsRetrieveErrors,
  type DirectvotingBallotsProposalsRetrieveResponse,
  type DirectvotingBallotsProposalsRetrieveResponses,
  type DirectvotingBallotsSearchCreateData,
  type DirectvotingBallotsSearchCreateErrors,
  type DirectvotingBallotsSearchCreateResponse,
  type DirectvotingBallotsSearchCreateResponses,
  type DirectVotingBallotStamp,
  type DirectvotingBallotStampsRetrieveData,
  type DirectvotingBallotStampsRetrieveErrors,
  type DirectvotingBallotStampsRetrieveResponse,
  type DirectvotingBallotStampsRetrieveResponses,
  type DirectvotingBallotStampsSearchCreateData,
  type DirectvotingBallotStampsSearchCreateErrors,
  type DirectvotingBallotStampsSearchCreateResponse,
  type DirectvotingBallotStampsSearchCreateResponses,
  type DirectVotingBallotWorkflowItem,
  type DirectVotingBallotWorkflowItemRequest,
  type DirectvotingBallotWorkflowItemsCreateData,
  type DirectvotingBallotWorkflowItemsCreateErrors,
  type DirectvotingBallotWorkflowItemsCreateResponse,
  type DirectvotingBallotWorkflowItemsCreateResponses,
  type DirectvotingBallotWorkflowItemsDestroyData,
  type DirectvotingBallotWorkflowItemsDestroyErrors,
  type DirectvotingBallotWorkflowItemsDestroyResponse,
  type DirectvotingBallotWorkflowItemsDestroyResponses,
  type DirectVotingBallotWorkflowItemSearchRequestRequest,
  type DirectvotingBallotWorkflowItemsPartialUpdateData,
  type DirectvotingBallotWorkflowItemsPartialUpdateErrors,
  type DirectvotingBallotWorkflowItemsPartialUpdateResponse,
  type DirectvotingBallotWorkflowItemsPartialUpdateResponses,
  type DirectvotingBallotWorkflowItemsRetrieveData,
  type DirectvotingBallotWorkflowItemsRetrieveErrors,
  type DirectvotingBallotWorkflowItemsRetrieveResponse,
  type DirectvotingBallotWorkflowItemsRetrieveResponses,
  type DirectvotingBallotWorkflowItemsSearchCreateData,
  type DirectvotingBallotWorkflowItemsSearchCreateErrors,
  type DirectvotingBallotWorkflowItemsSearchCreateResponse,
  type DirectvotingBallotWorkflowItemsSearchCreateResponses,
  type DirectVotingBallotWorkflowItemWritable,
  type DirectVotingBeaconRuleOutput,
  type DirectVotingBeaconRuleOutputProposal,
  type DirectVotingBeaconRuleOutputProposalResultRequest,
  type DirectvotingBeaconRuleOutputsCreateData,
  type DirectvotingBeaconRuleOutputsCreateErrors,
  type DirectvotingBeaconRuleOutputsCreateResponse,
  type DirectvotingBeaconRuleOutputsCreateResponses,
  type DirectvotingBeaconRuleOutputsDestroyData,
  type DirectvotingBeaconRuleOutputsDestroyErrors,
  type DirectvotingBeaconRuleOutputsDestroyResponse,
  type DirectvotingBeaconRuleOutputsDestroyResponses,
  type DirectVotingBeaconRuleOutputSearchRequestRequest,
  type DirectvotingBeaconRuleOutputsRetrieveData,
  type DirectvotingBeaconRuleOutputsRetrieveErrors,
  type DirectvotingBeaconRuleOutputsRetrieveResponse,
  type DirectvotingBeaconRuleOutputsRetrieveResponses,
  type DirectvotingBeaconRuleOutputsSearchCreateData,
  type DirectvotingBeaconRuleOutputsSearchCreateErrors,
  type DirectvotingBeaconRuleOutputsSearchCreateResponse,
  type DirectvotingBeaconRuleOutputsSearchCreateResponses,
  type DirectVotingBeaconRuleOutputUpsertRequest,
  type DirectvotingCustodyAccountGroupMembershipsCreateData,
  type DirectvotingCustodyAccountGroupMembershipsCreateErrors,
  type DirectvotingCustodyAccountGroupMembershipsCreateResponse,
  type DirectvotingCustodyAccountGroupMembershipsCreateResponses,
  type DirectvotingCustodyAccountGroupMembershipsDestroyData,
  type DirectvotingCustodyAccountGroupMembershipsDestroyErrors,
  type DirectvotingCustodyAccountGroupMembershipsDestroyResponse,
  type DirectvotingCustodyAccountGroupMembershipsDestroyResponses,
  type DirectvotingCustodyAccountGroupMembershipsSearchCreateData,
  type DirectvotingCustodyAccountGroupMembershipsSearchCreateErrors,
  type DirectvotingCustodyAccountGroupMembershipsSearchCreateResponse,
  type DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses,
  type DirectvotingCustodyAccountGroupsCreateData,
  type DirectvotingCustodyAccountGroupsCreateErrors,
  type DirectvotingCustodyAccountGroupsCreateResponse,
  type DirectvotingCustodyAccountGroupsCreateResponses,
  type DirectvotingCustodyAccountGroupsDestroyData,
  type DirectvotingCustodyAccountGroupsDestroyErrors,
  type DirectvotingCustodyAccountGroupsDestroyResponse,
  type DirectvotingCustodyAccountGroupsDestroyResponses,
  type DirectvotingCustodyAccountGroupsPartialUpdateData,
  type DirectvotingCustodyAccountGroupsPartialUpdateErrors,
  type DirectvotingCustodyAccountGroupsPartialUpdateResponse,
  type DirectvotingCustodyAccountGroupsPartialUpdateResponses,
  type DirectvotingCustodyAccountGroupsRetrieveData,
  type DirectvotingCustodyAccountGroupsRetrieveErrors,
  type DirectvotingCustodyAccountGroupsRetrieveResponse,
  type DirectvotingCustodyAccountGroupsRetrieveResponses,
  type DirectvotingCustodyAccountGroupsSearchCreateData,
  type DirectvotingCustodyAccountGroupsSearchCreateErrors,
  type DirectvotingCustodyAccountGroupsSearchCreateResponse,
  type DirectvotingCustodyAccountGroupsSearchCreateResponses,
  type DirectvotingCustodyAccountGroupsUpdateData,
  type DirectvotingCustodyAccountGroupsUpdateErrors,
  type DirectvotingCustodyAccountGroupsUpdateResponse,
  type DirectvotingCustodyAccountGroupsUpdateResponses,
  type DirectvotingCustodyAccountTenantLinksLinkCreateData,
  type DirectvotingCustodyAccountTenantLinksLinkCreateErrors,
  type DirectvotingCustodyAccountTenantLinksLinkCreateResponse,
  type DirectvotingCustodyAccountTenantLinksLinkCreateResponses,
  type DirectvotingCustodyAccountTenantLinksListData,
  type DirectvotingCustodyAccountTenantLinksListErrors,
  type DirectvotingCustodyAccountTenantLinksListResponse,
  type DirectvotingCustodyAccountTenantLinksListResponses,
  type DirectvotingCustodyAccountTenantLinksUnlinkCreateData,
  type DirectvotingCustodyAccountTenantLinksUnlinkCreateErrors,
  type DirectvotingCustodyAccountTenantLinksUnlinkCreateResponse,
  type DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsCreateData,
  type DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsDestroyData,
  type DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData,
  type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData,
  type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData,
  type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses,
  type DirectvotingCustodyAccountVotingPolicySelectionsUpdateData,
  type DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors,
  type DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse,
  type DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses,
  type DirectvotingMeetingsAssignmentSearchCreateData,
  type DirectvotingMeetingsAssignmentSearchCreateErrors,
  type DirectvotingMeetingsAssignmentSearchCreateResponse,
  type DirectvotingMeetingsAssignmentSearchCreateResponses,
  type DirectvotingMeetingsSearchCreateData,
  type DirectvotingMeetingsSearchCreateErrors,
  type DirectvotingMeetingsSearchCreateResponse,
  type DirectvotingMeetingsSearchCreateResponses,
  type DirectVotingRulesEngineRule,
  type DirectVotingRulesEngineRuleRequest,
  type DirectvotingRulesEngineRulesCreateData,
  type DirectvotingRulesEngineRulesCreateErrors,
  type DirectvotingRulesEngineRulesCreateResponse,
  type DirectvotingRulesEngineRulesCreateResponses,
  type DirectvotingRulesEngineRulesDestroyData,
  type DirectvotingRulesEngineRulesDestroyErrors,
  type DirectvotingRulesEngineRulesDestroyResponse,
  type DirectvotingRulesEngineRulesDestroyResponses,
  type DirectVotingRulesEngineRuleSearchRequestRequest,
  type DirectVotingRulesEngineRulesList,
  type DirectVotingRulesEngineRulesListRequest,
  type DirectvotingRulesEngineRulesListsCreateData,
  type DirectvotingRulesEngineRulesListsCreateErrors,
  type DirectvotingRulesEngineRulesListsCreateResponse,
  type DirectvotingRulesEngineRulesListsCreateResponses,
  type DirectvotingRulesEngineRulesListsDestroyData,
  type DirectvotingRulesEngineRulesListsDestroyErrors,
  type DirectvotingRulesEngineRulesListsDestroyResponse,
  type DirectvotingRulesEngineRulesListsDestroyResponses,
  type DirectVotingRulesEngineRulesListSearchRequestRequest,
  type DirectvotingRulesEngineRulesListsPartialUpdateData,
  type DirectvotingRulesEngineRulesListsPartialUpdateErrors,
  type DirectvotingRulesEngineRulesListsPartialUpdateResponse,
  type DirectvotingRulesEngineRulesListsPartialUpdateResponses,
  type DirectvotingRulesEngineRulesListsRetrieveData,
  type DirectvotingRulesEngineRulesListsRetrieveErrors,
  type DirectvotingRulesEngineRulesListsRetrieveResponse,
  type DirectvotingRulesEngineRulesListsRetrieveResponses,
  type DirectvotingRulesEngineRulesListsSearchCreateData,
  type DirectvotingRulesEngineRulesListsSearchCreateErrors,
  type DirectvotingRulesEngineRulesListsSearchCreateResponse,
  type DirectvotingRulesEngineRulesListsSearchCreateResponses,
  type DirectVotingRulesEngineRulesListWritable,
  type DirectvotingRulesEngineRulesPartialUpdateData,
  type DirectvotingRulesEngineRulesPartialUpdateErrors,
  type DirectvotingRulesEngineRulesPartialUpdateResponse,
  type DirectvotingRulesEngineRulesPartialUpdateResponses,
  type DirectvotingRulesEngineRulesRetrieveData,
  type DirectvotingRulesEngineRulesRetrieveErrors,
  type DirectvotingRulesEngineRulesRetrieveResponse,
  type DirectvotingRulesEngineRulesRetrieveResponses,
  type DirectvotingRulesEngineRulesSearchCreateData,
  type DirectvotingRulesEngineRulesSearchCreateErrors,
  type DirectvotingRulesEngineRulesSearchCreateResponse,
  type DirectvotingRulesEngineRulesSearchCreateResponses,
  type DirectVotingRulesEngineRuleWritable,
  DirectVotingRuleTypeEnum,
  type DirectVotingWatchlist,
  type DirectVotingWatchlistItem,
  type DirectVotingWatchlistItemBatchUpsertRequest,
  type DirectVotingWatchlistItemBatchUpsertResponse,
  type DirectVotingWatchlistItemBatchUpsertResponseWritable,
  type DirectVotingWatchlistItemIssuer,
  type DirectVotingWatchlistItemRequest,
  type DirectVotingWatchlistItemRequestWritable,
  type DirectvotingWatchlistItemsBatchCreateData,
  type DirectvotingWatchlistItemsBatchCreateErrors,
  type DirectvotingWatchlistItemsBatchCreateResponse,
  type DirectvotingWatchlistItemsBatchCreateResponses,
  type DirectvotingWatchlistItemsCreateData,
  type DirectvotingWatchlistItemsCreateErrors,
  type DirectvotingWatchlistItemsCreateResponse,
  type DirectvotingWatchlistItemsCreateResponses,
  type DirectvotingWatchlistItemsDestroyData,
  type DirectvotingWatchlistItemsDestroyErrors,
  type DirectvotingWatchlistItemsDestroyResponse,
  type DirectvotingWatchlistItemsDestroyResponses,
  type DirectVotingWatchlistItemSearchRequestRequest,
  type DirectvotingWatchlistItemsRetrieveData,
  type DirectvotingWatchlistItemsRetrieveErrors,
  type DirectvotingWatchlistItemsRetrieveResponse,
  type DirectvotingWatchlistItemsRetrieveResponses,
  type DirectvotingWatchlistItemsSearchCreateData,
  type DirectvotingWatchlistItemsSearchCreateErrors,
  type DirectvotingWatchlistItemsSearchCreateResponse,
  type DirectvotingWatchlistItemsSearchCreateResponses,
  type DirectVotingWatchlistItemWritable,
  type DirectVotingWatchlistRequest,
  type DirectvotingWatchlistsCreateData,
  type DirectvotingWatchlistsCreateErrors,
  type DirectvotingWatchlistsCreateResponse,
  type DirectvotingWatchlistsCreateResponses,
  type DirectvotingWatchlistsDestroyData,
  type DirectvotingWatchlistsDestroyErrors,
  type DirectvotingWatchlistsDestroyResponse,
  type DirectvotingWatchlistsDestroyResponses,
  type DirectVotingWatchlistSearchRequestRequest,
  type DirectvotingWatchlistsPartialUpdateData,
  type DirectvotingWatchlistsPartialUpdateErrors,
  type DirectvotingWatchlistsPartialUpdateResponse,
  type DirectvotingWatchlistsPartialUpdateResponses,
  type DirectvotingWatchlistsRetrieveData,
  type DirectvotingWatchlistsRetrieveErrors,
  type DirectvotingWatchlistsRetrieveResponse,
  type DirectvotingWatchlistsRetrieveResponses,
  type DirectvotingWatchlistsSearchCreateData,
  type DirectvotingWatchlistsSearchCreateErrors,
  type DirectvotingWatchlistsSearchCreateResponse,
  type DirectvotingWatchlistsSearchCreateResponses,
  type DirectVotingWatchlistWritable,
  type Exchange,
  type ExportResult,
  type ExternalMeetingId,
  type ExternalMeetingIdCreateRequest,
  type FetchByVersionIdsRequestRequest,
  type FetchLatestBroadridgeProposalSetRequest,
  type FetchLatestBroadridgeProposalSetResponse,
  type FetchLatestProxymityProposalSetRequest,
  type FetchLatestProxymityProposalSetResponse,
  type FetchMinimalInstrumentsRequestRequest,
  type FetchMinimalInstrumentsResponse,
  type FetchMinimalInstrumentsResponseWritable,
  type FetchProposalLabelsRequest,
  type FetchProposalLabelsResponse,
  FilterReasonsEnum,
  type FiscalYear,
  type FiscalYearSearchRequestRequest,
  type FiscalYearUpsertRequestRequest,
  type FiscalYearUpsertResponse,
  FiscalYearUpsertStatusEnum,
  type Fund,
  type FundCustodianIdentifiers,
  type FundCustodianIdentifiersRequest,
  type FundManager,
  type FundManagerFundManagersCreateData,
  type FundManagerFundManagersCreateResponse,
  type FundManagerFundManagersCreateResponses,
  type FundManagerFundManagersPoliciesCreateData,
  type FundManagerFundManagersPoliciesCreateResponse,
  type FundManagerFundManagersPoliciesCreateResponses,
  type FundManagerFundManagersPoliciesRetrieveData,
  type FundManagerFundManagersPoliciesRetrieveResponse,
  type FundManagerFundManagersPoliciesRetrieveResponses,
  type FundManagerFundManagersRetrieveData,
  type FundManagerFundManagersRetrieveResponse,
  type FundManagerFundManagersRetrieveResponses,
  type FundManagerFundManagersSearchCreateData,
  type FundManagerFundManagersSearchCreateResponse,
  type FundManagerFundManagersSearchCreateResponses,
  type FundManagerFundManagersUpdateData,
  type FundManagerFundManagersUpdateResponse,
  type FundManagerFundManagersUpdateResponses,
  type FundManagerFundsCreateData,
  type FundManagerFundsCreateResponse,
  type FundManagerFundsCreateResponses,
  type FundManagerFundsQuantificationSnapshotsCreateData,
  type FundManagerFundsQuantificationSnapshotsCreateResponse,
  type FundManagerFundsQuantificationSnapshotsCreateResponses,
  type FundManagerFundsRetrieveData,
  type FundManagerFundsRetrieveResponse,
  type FundManagerFundsRetrieveResponses,
  type FundManagerFundsSearchCreateData,
  type FundManagerFundsSearchCreateResponse,
  type FundManagerFundsSearchCreateResponses,
  type FundManagerFundsUpdateData,
  type FundManagerFundsUpdateResponse,
  type FundManagerFundsUpdateResponses,
  type FundManagerFundVariantsCreateData,
  type FundManagerFundVariantsCreateResponse,
  type FundManagerFundVariantsCreateResponses,
  type FundManagerFundVariantsDestroyData,
  type FundManagerFundVariantsDestroyResponse,
  type FundManagerFundVariantsDestroyResponses,
  type FundManagerFundVariantsRetrieveData,
  type FundManagerFundVariantsRetrieveResponse,
  type FundManagerFundVariantsRetrieveResponses,
  type FundManagerFundVariantsSearchCreateData,
  type FundManagerFundVariantsSearchCreateResponse,
  type FundManagerFundVariantsSearchCreateResponses,
  type FundManagerFundVariantsUpdateData,
  type FundManagerFundVariantsUpdateResponse,
  type FundManagerFundVariantsUpdateResponses,
  type FundManagerPolicy,
  type FundManagerPolicyListResponse,
  type FundManagerPolicySii,
  type FundManagerPolicySiiBatchCreateRequest,
  type FundManagerPolicySiiBatchDeleteRequest,
  type FundManagerPolicySiiInputRequest,
  type FundManagerPolicySiiResponse,
  type FundManagerPolicySiiResponseWritable,
  type FundManagerPolicySiiSearchRequestRequest,
  type FundManagerPolicySiiWritable,
  type FundManagerProvidersCreateData,
  type FundManagerProvidersCreateResponse,
  type FundManagerProvidersCreateResponses,
  type FundManagerProvidersListData,
  type FundManagerProvidersListResponse,
  type FundManagerProvidersListResponses,
  type FundManagerProvidersRetrieveData,
  type FundManagerProvidersRetrieveResponse,
  type FundManagerProvidersRetrieveResponses,
  type FundManagerProvidersUpdateData,
  type FundManagerProvidersUpdateResponse,
  type FundManagerProvidersUpdateResponses,
  type FundManagerPublicSecurityId,
  type FundManagerPublicSecurityIdsCreateData,
  type FundManagerPublicSecurityIdsCreateResponse,
  type FundManagerPublicSecurityIdsCreateResponses,
  type FundManagerPublicSecurityIdSearchRequestRequest,
  type FundManagerPublicSecurityIdsSearchCreateData,
  type FundManagerPublicSecurityIdsSearchCreateResponse,
  type FundManagerPublicSecurityIdsSearchCreateResponses,
  type FundManagerPublicSecurityIdWriteRequest,
  type FundManagerQuantificationSnapshotsSearchCreateData,
  type FundManagerQuantificationSnapshotsSearchCreateResponse,
  type FundManagerQuantificationSnapshotsSearchCreateResponses,
  type FundManagerSearchRequestRequest,
  type FundManagerSupportedIssuedInstrumentsQueryRequest,
  type FundManagerSupportedVotingPolicy,
  type FundManagerSupportedVotingPolicyBatchUpsertRequest,
  type FundManagerSupportedVotingPolicyBatchUpsertResponse,
  type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable,
  type FundManagerSupportedVotingPolicyHistorical,
  type FundManagerSupportedVotingPolicyItemRequest,
  type FundManagerWritable,
  type FundManagerWriteRequest,
  type FundProxyIntermediaryIdentifiers,
  type FundProxyIntermediaryIdentifiersRequest,
  type FundQuantificationSnapshot,
  type FundQuantificationSnapshotSearchRequestRequest,
  type FundQuantificationSnapshotWritable,
  type FundQuantificationSnapshotWriteRequest,
  type FundSearchRequestRequest,
  type FundVariant,
  type FundVariantQuantificationSet,
  type FundVariantQuantificationSetRequest,
  type FundVariantSearchRequestRequest,
  type FundVariantWritable,
  type FundVariantWriteRequest,
  type FundWritable,
  type FundWriteRequest,
  type GeneralMeeting,
  type GeneralMeetingSearchRequestRequest,
  GeneralMeetingTypeEnum,
  type GeneralMeetingWritable,
  type GeneralMeetingWriteRequest,
  GeneralMeetingWriteTypeEnum,
  type GetOrganizationByIdentifierRequestRequest,
  type Holding,
  type HoldingInputRequest,
  type HoldingResponse,
  type HoldingResponseWritable,
  type HoldingWritable,
  IdentifierTypeEnum,
  IdentitySourceEnum,
  type Industry,
  type IndustryNaics,
  type IndustryNaicsRequest,
  type IndustryNaicsWritable,
  type IndustryRequest,
  type IndustryWritable,
  type InstitutionalMeetingsearchListData,
  type InstitutionalMeetingsearchListResponse,
  type InstitutionalMeetingsearchListResponses,
  type Instrument,
  InstrumentIdentifierTypeEnum,
  type InstrumentSearchRequestRequest,
  type InstrumentUpsertRequestRequest,
  type InstrumentUpsertResponse,
  type InstrumentWritable,
  type InstrumentWriteRequest,
  type InvestorAccountVoteInfo,
  type InvestorPolicySii,
  type InvestorPolicySiiBatchCreateRequest,
  type InvestorPolicySiiBatchDeleteRequest,
  type InvestorPolicySiiInputRequest,
  type InvestorPolicySiiResponse,
  type InvestorPolicySiiResponseWritable,
  type InvestorPolicySiiSearchRequestRequest,
  type InvestorPolicySiiWritable,
  type InvestorRulesEngine,
  type InvestorRulesEngineRequest,
  type InvestorRulesEngineWritable,
  type InvestorsCanVoteRequest,
  type InvestorsCanVoteResponse,
  type InvestorSiiBatchCreateRequest,
  type InvestorSiiBatchDeleteRequest,
  type InvestorSiiInputRequest,
  type InvestorSiiResponse,
  type InvestorSiiResponseWritable,
  type InvestorSiiSearchRequestRequest,
  type InvestorSupportedIssuedInstrument,
  type InvestorSupportedIssuedInstrumentWritable,
  type Issuer,
  type IssuerFiscalYearsCreateData,
  type IssuerFiscalYearsCreateErrors,
  type IssuerFiscalYearsCreateResponse,
  type IssuerFiscalYearsCreateResponses,
  type IssuerFiscalYearsSearchCreateData,
  type IssuerFiscalYearsSearchCreateErrors,
  type IssuerFiscalYearsSearchCreateResponse,
  type IssuerFiscalYearsSearchCreateResponses,
  type IssuerInstrument,
  type IssuerInstrumentsCreateData,
  type IssuerInstrumentsCreateErrors,
  type IssuerInstrumentsCreateResponse,
  type IssuerInstrumentsCreateResponses,
  type IssuerInstrumentSearchRequestRequest,
  type IssuerInstrumentsOutstandingSharesCreateData,
  type IssuerInstrumentsOutstandingSharesCreateErrors,
  type IssuerInstrumentsOutstandingSharesCreateResponse,
  type IssuerInstrumentsOutstandingSharesCreateResponses,
  type IssuerInstrumentsOutstandingSharesRetrieveData,
  type IssuerInstrumentsOutstandingSharesRetrieveErrors,
  type IssuerInstrumentsOutstandingSharesRetrieveResponse,
  type IssuerInstrumentsOutstandingSharesRetrieveResponses,
  type IssuerInstrumentsRetrieveData,
  type IssuerInstrumentsRetrieveErrors,
  type IssuerInstrumentsRetrieveResponse,
  type IssuerInstrumentsRetrieveResponses,
  type IssuerInstrumentsSearchCreateData,
  type IssuerInstrumentsSearchCreateErrors,
  type IssuerInstrumentsSearchCreateResponse,
  type IssuerInstrumentsSearchCreateResponses,
  type IssuerInstrumentsTotalShareholderReturnCreateData,
  type IssuerInstrumentsTotalShareholderReturnCreateErrors,
  type IssuerInstrumentsTotalShareholderReturnCreateResponse,
  type IssuerInstrumentsTotalShareholderReturnCreateResponses,
  type IssuerInstrumentsTotalShareholderReturnRetrieveData,
  type IssuerInstrumentsTotalShareholderReturnRetrieveErrors,
  type IssuerInstrumentsTotalShareholderReturnRetrieveResponse,
  type IssuerInstrumentsTotalShareholderReturnRetrieveResponses,
  type IssuerIssuersCreateData,
  type IssuerIssuersCreateErrors,
  type IssuerIssuersCreateResponse,
  type IssuerIssuersCreateResponses,
  type IssuerIssuersMarketCapitalisationCreateData,
  type IssuerIssuersMarketCapitalisationCreateErrors,
  type IssuerIssuersMarketCapitalisationCreateResponse,
  type IssuerIssuersMarketCapitalisationCreateResponses,
  type IssuerIssuersMarketCapitalisationRetrieveData,
  type IssuerIssuersMarketCapitalisationRetrieveErrors,
  type IssuerIssuersMarketCapitalisationRetrieveResponse,
  type IssuerIssuersMarketCapitalisationRetrieveResponses,
  type IssuerIssuersRetrieveData,
  type IssuerIssuersRetrieveErrors,
  type IssuerIssuersRetrieveResponse,
  type IssuerIssuersRetrieveResponses,
  type IssuerIssuersSearchBySecurityIdsCreateData,
  type IssuerIssuersSearchBySecurityIdsCreateErrors,
  type IssuerIssuersSearchBySecurityIdsCreateResponse,
  type IssuerIssuersSearchBySecurityIdsCreateResponses,
  type IssuerIssuersSearchCreateData,
  type IssuerIssuersSearchCreateErrors,
  type IssuerIssuersSearchCreateResponse,
  type IssuerIssuersSearchCreateResponses,
  type IssuerSearchRequestRequest,
  type IssuerSecurityIdMatch,
  type IssuerSecurityIdsSearchRequestRequest,
  type IssuerSecurityIdsSearchResponse,
  type IssuerUpsertRequestRequest,
  type IssuerUpsertResponse,
  LinkedEnum,
  type ListProposalCategoriesRequest,
  type ListProposalCategoriesResponse,
  type ListRequestRequest,
  type MarketCapitalisation,
  type MarketCapitalisationUpsertRequest,
  type MatchProxyIntermediaryVotingRecommendationFromPvrRequest,
  MatchStatusEnum,
  type MatchVotingRecommendationFromPvrRequest,
  type MeasureUpsertResponse,
  MeasureUpsertStatusEnum,
  type Meeting,
  type MeetingAssignment,
  type MeetingAssignmentBallot,
  MeetingAssignmentOrderingFieldEnum,
  type MeetingAssignmentOrderingRequest,
  type MeetingAssignmentSearchRequestRequest,
  type MeetingAssignmentWritable,
  type MeetingBallot,
  type MeetingBallotSource,
  type MeetingBallotSourceWritable,
  type MeetingBallotWritable,
  MeetingTypeEnum,
  type MeetingWritable,
  type MinimalInstrument,
  type MinimalInstrumentWritable,
  type Organization,
  type OrganizationAddress,
  type OrganizationAddressRequest,
  type OrganizationBio,
  type OrganizationBioRequest,
  type OrganizationIdentifier,
  type OrganizationIdentifierRequest,
  type OrganizationLogoUploadRequest,
  type OrganizationSearchRequestRequest,
  OrganizationTypeEnum,
  type OrganizationWritable,
  type OrganizationWriteRequest,
  type OutstandingShares,
  type OutstandingSharesUpsertRequest,
  type PaginatedAuditEventList,
  type PaginatedAuditEventListWritable,
  type PaginatedBallotEntitlementList,
  type PaginatedBallotEntitlementListWritable,
  type PaginatedBallotList,
  type PaginatedCustodyAccountGroupList,
  type PaginatedCustodyAccountGroupListWritable,
  type PaginatedCustodyAccountGroupMembershipList,
  type PaginatedCustodyAccountGroupMembershipListWritable,
  type PaginatedCustodyAccountList,
  type PaginatedCustodyAccountListWritable,
  type PaginatedCustodyAccountTenantLinkList,
  type PaginatedCustodyAccountTenantLinkListWritable,
  type PaginatedCustodyAccountVotingPolicySelectionList,
  type PaginatedCustodyAccountVotingPolicySelectionListWritable,
  type PaginatedDirectVotingBallotStampList,
  type PaginatedDirectVotingBallotStampListWritable,
  type PaginatedDirectVotingBallotWorkflowItemList,
  type PaginatedDirectVotingBallotWorkflowItemListWritable,
  type PaginatedDirectVotingBeaconRuleOutputList,
  type PaginatedDirectVotingBeaconRuleOutputListWritable,
  type PaginatedDirectVotingRulesEngineRuleList,
  type PaginatedDirectVotingRulesEngineRuleListWritable,
  type PaginatedDirectVotingRulesEngineRulesListList,
  type PaginatedDirectVotingRulesEngineRulesListListWritable,
  type PaginatedDirectVotingWatchlistItemList,
  type PaginatedDirectVotingWatchlistItemListWritable,
  type PaginatedDirectVotingWatchlistList,
  type PaginatedDirectVotingWatchlistListWritable,
  type PaginatedFiscalYearList,
  type PaginatedFiscalYearListWritable,
  type PaginatedFundList,
  type PaginatedFundListWritable,
  type PaginatedFundManagerList,
  type PaginatedFundManagerListWritable,
  type PaginatedFundManagerPolicySiiList,
  type PaginatedFundManagerPolicySiiListWritable,
  type PaginatedFundManagerPublicSecurityIdList,
  type PaginatedFundManagerSupportedVotingPolicyHistoricalList,
  type PaginatedFundQuantificationSnapshotList,
  type PaginatedFundQuantificationSnapshotListWritable,
  type PaginatedFundVariantList,
  type PaginatedFundVariantListWritable,
  type PaginatedGeneralMeetingList,
  type PaginatedGeneralMeetingListWritable,
  type PaginatedInstrumentList,
  type PaginatedInstrumentListWritable,
  type PaginatedInvestorPolicySiiList,
  type PaginatedInvestorPolicySiiListWritable,
  type PaginatedInvestorSupportedIssuedInstrumentList,
  type PaginatedInvestorSupportedIssuedInstrumentListWritable,
  type PaginatedIssuerInstrumentList,
  type PaginatedIssuerInstrumentListWritable,
  type PaginatedIssuerList,
  type PaginatedIssuerListWritable,
  type PaginatedMeetingAssignmentList,
  type PaginatedMeetingAssignmentListWritable,
  type PaginatedMeetingBallotList,
  type PaginatedMeetingBallotListWritable,
  type PaginatedMeetingBallotSourceList,
  type PaginatedMeetingBallotSourceListWritable,
  type PaginatedMeetingList,
  type PaginatedMeetingListWritable,
  type PaginatedOrganizationList,
  type PaginatedOrganizationListWritable,
  type PaginatedPermissionGroupAssignmentList,
  type PaginatedPermissionGroupList,
  type PaginatedPiBallotSearchList,
  type PaginatedPiBallotSearchListWritable,
  type PaginatedPiMeetingSearchList,
  type PaginatedPiMeetingSearchListWritable,
  type PaginatedProposalList,
  type PaginatedProposalListWritable,
  type PaginatedProposalSetRecommendationCoverageList,
  type PaginatedProviderList,
  type PaginatedProviderListWritable,
  type PaginatedProviderVotingRecommendationList,
  type PaginatedProxyIntermediaryList,
  type PaginatedProxyIntermediaryListWritable,
  type PaginatedProxyIntermediaryMeetingAuditEventList,
  type PaginatedProxyIntermediaryMeetingAuditEventListWritable,
  type PaginatedProxyIntermediaryMeetingList,
  type PaginatedProxyIntermediaryMeetingListWritable,
  type PaginatedProxyIntermediaryProposalList,
  type PaginatedProxyIntermediaryProposalListWritable,
  type PaginatedProxyIntermediaryVotingRecommendationList,
  type PaginatedPublicSecurityIdList,
  type PaginatedPublicSecurityIdListWritable,
  type PaginatedRoleAssignmentList,
  type PaginatedRoleList,
  type PaginatedRoleListWritable,
  type PaginatedRulesEngineDefinitionList,
  type PaginatedRulesEngineDefinitionListWritable,
  type PaginatedRulesEngineRuleList,
  type PaginatedRulesEngineRuleListWritable,
  type PaginatedSplitVoteInstructionOverwriteReasonList,
  type PaginatedTenantBallotList,
  type PaginatedTenantBallotListWritable,
  type PaginatedTenantList,
  type PaginatedTenantMeetingList,
  type PaginatedUserList,
  type PaginatedVotingPolicyDocumentList,
  type PaginatedVotingPolicyDocumentListWritable,
  type PaginatedVotingPolicyList,
  type PaginatedVotingPolicyListWritable,
  type PaginatedVotingRecommendationList,
  type PaginatedVotingRecommendationListWritable,
  type PatchedCustodyAccountGroupRequest,
  type PatchedCustodyAccountRequest,
  type PatchedCustodyAccountVotingPolicySelectionRequest,
  type PatchedDirectVotingBallotWorkflowItemRequest,
  type PatchedDirectVotingRulesEngineRuleRequest,
  type PatchedDirectVotingRulesEngineRulesListRequest,
  type PatchedDirectVotingWatchlistRequest,
  type PatchedGeneralMeetingWriteRequest,
  type PatchedOrganizationWriteRequest,
  type PatchedProposalPatchRequest,
  type PatchedRoleRequest,
  type PatchedVotingPolicyDocumentUpdateRequest,
  type PatchedVotingPolicyUpdateRequest,
  type PatchedVotingRecommendationUpdateRequest,
  type PermissionGroup,
  type PermissionGroupAssignment,
  type PermissionGroupAssignmentCreateRequest,
  type PermissionGroupAssignmentSearchRequestRequest,
  type PermissionGroupAssignmentUpdateRequest,
  type PermissionGroupSearchRequestRequest,
  type PermissionGroupWriteRequest,
  type PiBallotSearch,
  type PiBallotSearchWritable,
  type PiMeetingSearch,
  type PiMeetingSearchWritable,
  PiProposalCategoryEnum,
  PiProposalCategorySourceEnum,
  PiProposalCategoryUpsertStatusEnum,
  PiProposalSubcategoryEnum,
  PiProposalTopicEnum,
  type Policy,
  PolicyInstructionEnum,
  type PolicyRequest,
  type PolicyResponse,
  type PolicyResponseWritable,
  type PolicyWritable,
  ProductEnum,
  type Proposal,
  type ProposalCategory,
  type ProposalClassificationCodesResponse,
  type ProposalCountRequestRequest,
  type ProposalCountResponse,
  type ProposalFetchNamesFromIdsRequestRequest,
  type ProposalFetchNamesFromIdsResponse,
  type ProposalFetchRequestRequest,
  type ProposalManagementRecommendation,
  type ProposalManagementRecommendationRequest,
  type ProposalOutcome,
  type ProposalOutcomeRequest,
  type ProposalOutcomeWritable,
  type ProposalPassThreshold,
  type ProposalPassThresholdRequest,
  type ProposalSearchRequestRequest,
  type ProposalSecClassificationCodesResponse,
  type ProposalSetRecommendationCoverage,
  type ProposalSetRecommendationCoverageDetail,
  type ProposalSetRecommendationCoverageDetailWritable,
  type ProposalSetRecommendationCoverageProposal,
  type ProposalSetRecommendationCoverageProposalWritable,
  type ProposalSetRecommendationCoverageSearchRequest,
  type ProposalVoteRequest,
  type ProposalVotes,
  type ProposalVotesRequest,
  type ProposalWritable,
  type ProposalWriteRequest,
  type Provider,
  type ProviderVotingRecommendation,
  type ProviderVotingRecommendationCreateRequest,
  type ProviderVotingRecommendationListResponse,
  type ProviderVotingRecommendationSearchRequest,
  type ProviderWritable,
  type ProviderWriteRequest,
  type ProxyEdgeVote,
  type ProxyEdgeVoteCreateRequestRequest,
  type ProxyEdgeVoteFetchLatestRequestRequest,
  type ProxyEdgeVoteHardDeleteRequestRequest,
  type ProxyEdgeVoteHardDeleteResponse,
  type ProxyEdgeVoteInstruction,
  type ProxyEdgeVoteInstructionCreateRequest,
  type ProxyEdgeVoteResponse,
  type ProxyIntermediary,
  type ProxyIntermediaryBallotsFetchByVersionIdsCreateData,
  type ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse,
  type ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses,
  type ProxyIntermediaryBallotsProxymityStaleProposalSetListData,
  type ProxyIntermediaryBallotsProxymityStaleProposalSetListResponse,
  type ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses,
  type ProxyIntermediaryBallotsSearchCreateData,
  type ProxyIntermediaryBallotsSearchCreateResponse,
  type ProxyIntermediaryBallotsSearchCreateResponses,
  type ProxyIntermediaryBallotsUpsertCreateData,
  type ProxyIntermediaryBallotsUpsertCreateResponse,
  type ProxyIntermediaryBallotsUpsertCreateResponses,
  type ProxyIntermediaryBallotsVersionsListData,
  type ProxyIntermediaryBallotsVersionsListResponse,
  type ProxyIntermediaryBallotsVersionsListResponses,
  type ProxyIntermediaryCustodyAccountsCreateData,
  type ProxyIntermediaryCustodyAccountsCreateErrors,
  type ProxyIntermediaryCustodyAccountsCreateResponse,
  type ProxyIntermediaryCustodyAccountsCreateResponses,
  type ProxyIntermediaryCustodyAccountsDestroyData,
  type ProxyIntermediaryCustodyAccountsDestroyErrors,
  type ProxyIntermediaryCustodyAccountsDestroyResponse,
  type ProxyIntermediaryCustodyAccountsDestroyResponses,
  type ProxyIntermediaryCustodyAccountsPartialUpdateData,
  type ProxyIntermediaryCustodyAccountsPartialUpdateErrors,
  type ProxyIntermediaryCustodyAccountsPartialUpdateResponse,
  type ProxyIntermediaryCustodyAccountsPartialUpdateResponses,
  type ProxyIntermediaryCustodyAccountsRetrieveData,
  type ProxyIntermediaryCustodyAccountsRetrieveErrors,
  type ProxyIntermediaryCustodyAccountsRetrieveResponse,
  type ProxyIntermediaryCustodyAccountsRetrieveResponses,
  type ProxyIntermediaryCustodyAccountsSearchCreateData,
  type ProxyIntermediaryCustodyAccountsSearchCreateErrors,
  type ProxyIntermediaryCustodyAccountsSearchCreateResponse,
  type ProxyIntermediaryCustodyAccountsSearchCreateResponses,
  type ProxyIntermediaryCustodyAccountsUpdateData,
  type ProxyIntermediaryCustodyAccountsUpdateErrors,
  type ProxyIntermediaryCustodyAccountsUpdateResponse,
  type ProxyIntermediaryCustodyAccountsUpdateResponses,
  ProxyIntermediaryEnum,
  type ProxyIntermediaryMeeting,
  type ProxyIntermediaryMeetingAuditEvent,
  type ProxyIntermediaryMeetingAuditEventSearchRequestRequest,
  type ProxyIntermediaryMeetingBatchCancelRequestRequest,
  type ProxyIntermediaryMeetingBatchCancelResponse,
  type ProxyIntermediaryMeetingBatchCancelResponseWritable,
  type ProxyIntermediaryMeetingHardDeleteRequestRequest,
  type ProxyIntermediaryMeetingHardDeleteResponse,
  type ProxyIntermediaryMeetingLinkRequestRequest,
  type ProxyIntermediaryMeetingResponse,
  type ProxyIntermediaryMeetingResponseWritable,
  ProxyIntermediaryMeetingSearchRequestCancelledEnum,
  type ProxyIntermediaryMeetingSearchRequestRequest,
  type ProxyIntermediaryMeetingSecurityIdsResponse,
  type ProxyIntermediaryMeetingUnlinkRequestRequest,
  type ProxyIntermediaryMeetingUpsertRequest,
  type ProxyIntermediaryMeetingUpsertRequestRequest,
  type ProxyIntermediaryMeetingUpsertResponse,
  ProxyIntermediaryMeetingUpsertResponseStatusEnum,
  type ProxyIntermediaryMeetingUpsertResponseWritable,
  type ProxyIntermediaryPiProposalCategoriesUpsertCreateData,
  type ProxyIntermediaryPiProposalCategoriesUpsertCreateResponse,
  type ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses,
  type ProxyIntermediaryProposal,
  type ProxyIntermediaryProposalCategoriesAssignCreateData,
  type ProxyIntermediaryProposalCategoriesAssignCreateResponse,
  type ProxyIntermediaryProposalCategoriesAssignCreateResponses,
  type ProxyIntermediaryProposalCategoriesListCreateData,
  type ProxyIntermediaryProposalCategoriesListCreateResponse,
  type ProxyIntermediaryProposalCategoriesListCreateResponses,
  type ProxyIntermediaryProposalLabelsAssignCreateData,
  type ProxyIntermediaryProposalLabelsAssignCreateResponse,
  type ProxyIntermediaryProposalLabelsAssignCreateResponses,
  type ProxyIntermediaryProposalLabelsFetchCreateData,
  type ProxyIntermediaryProposalLabelsFetchCreateResponse,
  type ProxyIntermediaryProposalLabelsFetchCreateResponses,
  type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateData,
  type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponse,
  type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses,
  type ProxyIntermediaryProposalsCreateCreateData,
  type ProxyIntermediaryProposalsCreateCreateResponse,
  type ProxyIntermediaryProposalsCreateCreateResponses,
  type ProxyIntermediaryProposalsDeleteCreateData,
  type ProxyIntermediaryProposalsDeleteCreateResponse,
  type ProxyIntermediaryProposalsDeleteCreateResponses,
  ProxyIntermediaryProposalSourceEnum,
  type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateData,
  type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponse,
  type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses,
  type ProxyIntermediaryProposalsSearchCreateData,
  type ProxyIntermediaryProposalsSearchCreateResponse,
  type ProxyIntermediaryProposalsSearchCreateResponses,
  type ProxyIntermediaryProposalWritable,
  type ProxyIntermediaryProxyedgeVotesCreateCreateData,
  type ProxyIntermediaryProxyedgeVotesCreateCreateResponse,
  type ProxyIntermediaryProxyedgeVotesCreateCreateResponses,
  type ProxyIntermediaryProxyedgeVotesFetchLatestCreateData,
  type ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponse,
  type ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses,
  type ProxyIntermediaryProxyedgeVotesHardDeleteCreateData,
  type ProxyIntermediaryProxyedgeVotesHardDeleteCreateResponse,
  type ProxyIntermediaryProxyedgeVotesHardDeleteCreateResponses,
  type ProxyIntermediaryProxyIntermediariesSearchCreateData,
  type ProxyIntermediaryProxyIntermediariesSearchCreateResponse,
  type ProxyIntermediaryProxyIntermediariesSearchCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsSecurityIdsRetrieveData,
  type ProxyIntermediaryProxyIntermediaryMeetingsSecurityIdsRetrieveResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsSecurityIdsRetrieveResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses,
  type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData,
  type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse,
  type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses,
  type ProxyIntermediaryProxymityVotesCreateCreateData,
  type ProxyIntermediaryProxymityVotesCreateCreateResponse,
  type ProxyIntermediaryProxymityVotesCreateCreateResponses,
  type ProxyIntermediaryProxymityVotesFetchLatestCreateData,
  type ProxyIntermediaryProxymityVotesFetchLatestCreateResponse,
  type ProxyIntermediaryProxymityVotesFetchLatestCreateResponses,
  type ProxyIntermediarySearchRequestRequest,
  type ProxyIntermediaryVoteStatusesDeleteCreateData,
  type ProxyIntermediaryVoteStatusesDeleteCreateResponse,
  type ProxyIntermediaryVoteStatusesDeleteCreateResponses,
  type ProxyIntermediaryVoteStatusesHardDeleteCreateData,
  type ProxyIntermediaryVoteStatusesHardDeleteCreateResponse,
  type ProxyIntermediaryVoteStatusesHardDeleteCreateResponses,
  type ProxyIntermediaryVoteStatusesUpsertCreateData,
  type ProxyIntermediaryVoteStatusesUpsertCreateResponse,
  type ProxyIntermediaryVoteStatusesUpsertCreateResponses,
  ProxyIntermediaryVotingOptionsEnum,
  type ProxyIntermediaryVotingRecommendation,
  type ProxyIntermediaryVotingRecommendationConfidenceScore,
  type ProxyIntermediaryVotingRecommendationConfidenceScoreUpsertRequest,
  type ProxyIntermediaryVotingRecommendationCreateRequest,
  type ProxyIntermediaryVotingRecommendationSearchRequest,
  type ProxyIntermediaryVotingRecommendationValidationStatus,
  type ProxyIntermediaryVotingRecommendationValidationStatusCreateRequest,
  type ProxyIntermediaryVotingRecommendationValidationStatusSearchRequest,
  type ProxyIntermediaryWritable,
  type ProxymityVote,
  type ProxymityVoteCreateRequestRequest,
  type ProxymityVoteFetchLatestRequestRequest,
  type ProxymityVoteInstruction,
  type ProxymityVoteInstructionCreateRequest,
  type ProxymityVoteResponse,
  type ProxySubmission,
  type ProxySubmissionRequest,
  type ProxyvotingEntitlementsBreakdownCreateData,
  type ProxyvotingEntitlementsBreakdownCreateResponse,
  type ProxyvotingEntitlementsBreakdownCreateResponses,
  type ProxyvotingEntitlementsComputeCreateData,
  type ProxyvotingEntitlementsComputeCreateResponse,
  type ProxyvotingEntitlementsComputeCreateResponses,
  type ProxyvotingEntitlementsListData,
  type ProxyvotingEntitlementsListResponse,
  type ProxyvotingEntitlementsListResponses,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingFundManagerSupportedPoliciesCreateData,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponse,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  type ProxyvotingFundManagerSupportedPoliciesDestroyData,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponse,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  type ProxyvotingFundManagerSupportedPoliciesListData,
  type ProxyvotingFundManagerSupportedPoliciesListResponse,
  type ProxyvotingFundManagerSupportedPoliciesListResponses,
  type ProxyvotingInvestorCompositionsDifferenceListData,
  type ProxyvotingInvestorCompositionsDifferenceListResponse,
  type ProxyvotingInvestorCompositionsDifferenceListResponses,
  type ProxyvotingInvestorCompositionsRenderCreateData,
  type ProxyvotingInvestorCompositionsRenderCreateResponse,
  type ProxyvotingInvestorCompositionsRenderCreateResponses,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingMeetingballotsComputeCreateData,
  type ProxyvotingMeetingballotsComputeCreateResponse,
  type ProxyvotingMeetingballotsComputeCreateResponses,
  type ProxyvotingMeetingBallotsListData,
  type ProxyvotingMeetingBallotsListResponse,
  type ProxyvotingMeetingBallotsListResponses,
  type ProxyvotingMeetingBallotSourcesListData,
  type ProxyvotingMeetingBallotSourcesListResponse,
  type ProxyvotingMeetingBallotSourcesListResponses,
  type ProxyvotingPiballotsFilterListData,
  type ProxyvotingPiballotsFilterListResponse,
  type ProxyvotingPiballotsFilterListResponses,
  type ProxyvotingPiballotsInvestorsCanVoteCreateData,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponse,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  type ProxyvotingPimeetingsFilterListData,
  type ProxyvotingPimeetingsFilterListResponse,
  type ProxyvotingPimeetingsFilterListResponses,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsCreateData,
  type ProxyvotingRulesEngineDefinitionsCreateResponse,
  type ProxyvotingRulesEngineDefinitionsCreateResponses,
  type ProxyvotingRulesEngineDefinitionsDestroyData,
  type ProxyvotingRulesEngineDefinitionsDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsListData,
  type ProxyvotingRulesEngineDefinitionsListResponse,
  type ProxyvotingRulesEngineDefinitionsListResponses,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRetrieveData,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRulesCreateData,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsRulesListData,
  type ProxyvotingRulesEngineDefinitionsRulesListResponse,
  type ProxyvotingRulesEngineDefinitionsRulesListResponses,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  type ProxyvotingSviProposalOverwriteCreateData,
  type ProxyvotingSviProposalOverwriteCreateResponse,
  type ProxyvotingSviProposalOverwriteCreateResponses,
  type ProxyvotingSviProposalOverwriteReasonsListData,
  type ProxyvotingSviProposalOverwriteReasonsListResponse,
  type ProxyvotingSviProposalOverwriteReasonsListResponses,
  type ProxyvotingSviSubmitVoteCreateData,
  type ProxyvotingSviSubmitVoteCreateResponse,
  type ProxyvotingSviSubmitVoteCreateResponses,
  type PublicSecurityId,
  type PublicSecurityIdListQueryRequest,
  type PublicSecurityIdWritable,
  type Quantification,
  type QuantificationRequest,
  RecommendationEnum,
  type RenderCompositionDifferenceRequest,
  ReportableReasonEnum,
  type Role,
  type RoleAssignment,
  type RoleAssignmentSearchRequestRequest,
  type RoleAssignmentWriteRequest,
  type RoleRequest,
  type RoleSearchRequestRequest,
  type RoleWritable,
  type RulesEngineDefinition,
  type RulesEngineDefinitionCreateRequest,
  type RulesEngineDefinitionWritable,
  RulesEngineEnum,
  type RulesEngineNamesResponse,
  type RulesEngineRule,
  type RulesEngineRuleWritable,
  type RulesEngineRuleWriteRequest,
  RuleTypeEnum,
  type SearchProposalRequest,
  SecurityIdLinkedFilterEnum,
  type SelectedPolicy,
  type SelectedPolicyRequestRequest,
  type SelectedPolicyResponse,
  type SelectedPolicyResponseWritable,
  type SelectedPolicyWritable,
  SourceEnum,
  type SplitVoteInstructionOverwriteReason,
  type SplitVoteInstructionProposalOverwrite,
  type SplitVoteInstructionProposalOverwriteRequest,
  type SplitVoteInstructionProposalOverwriteWritable,
  type SplitVoteInstructionSubmission,
  type SplitVoteInstructionSubmissionAcknowledgement,
  SplitVoteInstructionSubmissionAcknowledgementStatusEnum,
  StampTypeEnum,
  StampTypesEnum,
  type SubmitVoteRequestRequest,
  type SubmitVoteResponse,
  type SupportedIssuedInstrumentsQueryRequest,
  type TaskStatus,
  type TaskTriggered,
  type TenancyTenantsCreateData,
  type TenancyTenantsCreateResponse,
  type TenancyTenantsCreateResponses,
  type TenancyTenantsDestroyData,
  type TenancyTenantsDestroyResponse,
  type TenancyTenantsDestroyResponses,
  type TenancyTenantsRetrieveData,
  type TenancyTenantsRetrieveResponse,
  type TenancyTenantsRetrieveResponses,
  type TenancyTenantsSearchCreateData,
  type TenancyTenantsSearchCreateResponse,
  type TenancyTenantsSearchCreateResponses,
  type TenancyTenantsUpdateData,
  type TenancyTenantsUpdateResponse,
  type TenancyTenantsUpdateResponses,
  type TenancyUsersCreateData,
  type TenancyUsersCreateResponse,
  type TenancyUsersCreateResponses,
  type TenancyUsersDestroyData,
  type TenancyUsersDestroyResponse,
  type TenancyUsersDestroyResponses,
  type TenancyUsersRetrieveData,
  type TenancyUsersRetrieveResponse,
  type TenancyUsersRetrieveResponses,
  type TenancyUsersSearchCreateData,
  type TenancyUsersSearchCreateResponse,
  type TenancyUsersSearchCreateResponses,
  type TenancyUsersUpdateData,
  type TenancyUsersUpdateResponse,
  type TenancyUsersUpdateResponses,
  type Tenant,
  type TenantBallot,
  type TenantBallotSearchRequestRequest,
  type TenantBallotWritable,
  type TenantMeeting,
  type TenantMeetingIssuer,
  TenantMeetingOrderingFieldEnum,
  type TenantMeetingOrderingRequest,
  type TenantMeetingSearchRequestRequest,
  type TenantSearchRequestRequest,
  type TenantWriteRequest,
  type TotalShareholderReturn,
  type TotalShareholderReturnList,
  type TotalShareholderReturnListWritable,
  type TotalShareholderReturnUpsertRequest,
  type TransparencyAuditEventsSearchCreateData,
  type TransparencyAuditEventsSearchCreateResponse,
  type TransparencyAuditEventsSearchCreateResponses,
  type TransparencyExternalMeetingIdsCreateData,
  type TransparencyExternalMeetingIdsCreateResponse,
  type TransparencyExternalMeetingIdsCreateResponses,
  type TransparencyExternalMeetingIdsDestroyData,
  type TransparencyExternalMeetingIdsDestroyResponse,
  type TransparencyExternalMeetingIdsDestroyResponses,
  type TransparencyGeneralMeetingsCreateData,
  type TransparencyGeneralMeetingsCreateResponse,
  type TransparencyGeneralMeetingsCreateResponses,
  type TransparencyGeneralMeetingsPartialUpdateData,
  type TransparencyGeneralMeetingsPartialUpdateResponse,
  type TransparencyGeneralMeetingsPartialUpdateResponses,
  type TransparencyGeneralMeetingsRetrieveData,
  type TransparencyGeneralMeetingsRetrieveResponse,
  type TransparencyGeneralMeetingsRetrieveResponses,
  type TransparencyGeneralMeetingsSearchCreateData,
  type TransparencyGeneralMeetingsSearchCreateResponse,
  type TransparencyGeneralMeetingsSearchCreateResponses,
  type TransparencyInstrumentsCreateData,
  type TransparencyInstrumentsCreateResponse,
  type TransparencyInstrumentsCreateResponses,
  type TransparencyInstrumentsDestroyData,
  type TransparencyInstrumentsDestroyResponse,
  type TransparencyInstrumentsDestroyResponses,
  type TransparencyInstrumentsFetchMinimalCreateData,
  type TransparencyInstrumentsFetchMinimalCreateResponse,
  type TransparencyInstrumentsFetchMinimalCreateResponses,
  type TransparencyInstrumentsRetrieveData,
  type TransparencyInstrumentsRetrieveResponse,
  type TransparencyInstrumentsRetrieveResponses,
  type TransparencyInstrumentsSearchCreateData,
  type TransparencyInstrumentsSearchCreateResponse,
  type TransparencyInstrumentsSearchCreateResponses,
  type TransparencyInstrumentsUnassociatedRetrieveData,
  type TransparencyInstrumentsUnassociatedRetrieveResponse,
  type TransparencyInstrumentsUnassociatedRetrieveResponses,
  type TransparencyInstrumentsUpdateData,
  type TransparencyInstrumentsUpdateResponse,
  type TransparencyInstrumentsUpdateResponses,
  type TransparencyOrganizationsCreateData,
  type TransparencyOrganizationsCreateResponse,
  type TransparencyOrganizationsCreateResponses,
  type TransparencyOrganizationsDestroyData,
  type TransparencyOrganizationsDestroyResponse,
  type TransparencyOrganizationsDestroyResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
  type TransparencyOrganizationsGetByIdentifierCreateData,
  type TransparencyOrganizationsGetByIdentifierCreateResponse,
  type TransparencyOrganizationsGetByIdentifierCreateResponses,
  type TransparencyOrganizationsIsinsToNamesCreateData,
  type TransparencyOrganizationsIsinsToNamesCreateResponse,
  type TransparencyOrganizationsIsinsToNamesCreateResponses,
  type TransparencyOrganizationsLogoCreateData,
  type TransparencyOrganizationsLogoCreateResponse,
  type TransparencyOrganizationsLogoCreateResponses,
  type TransparencyOrganizationsPartialUpdateData,
  type TransparencyOrganizationsPartialUpdateResponse,
  type TransparencyOrganizationsPartialUpdateResponses,
  type TransparencyOrganizationsRetrieveData,
  type TransparencyOrganizationsRetrieveResponse,
  type TransparencyOrganizationsRetrieveResponses,
  type TransparencyOrganizationsSearchCreateData,
  type TransparencyOrganizationsSearchCreateResponse,
  type TransparencyOrganizationsSearchCreateResponses,
  type TransparencyOrganizationsUpdateData,
  type TransparencyOrganizationsUpdateResponse,
  type TransparencyOrganizationsUpdateResponses,
  type TransparencyProposalsClassificationCodesRetrieveData,
  type TransparencyProposalsClassificationCodesRetrieveResponse,
  type TransparencyProposalsClassificationCodesRetrieveResponses,
  type TransparencyProposalsCountCreateData,
  type TransparencyProposalsCountCreateResponse,
  type TransparencyProposalsCountCreateResponses,
  type TransparencyProposalsFetchCreateData,
  type TransparencyProposalsFetchCreateResponse,
  type TransparencyProposalsFetchCreateResponses,
  type TransparencyProposalsFetchNamesFromIdsCreateData,
  type TransparencyProposalsFetchNamesFromIdsCreateResponse,
  type TransparencyProposalsFetchNamesFromIdsCreateResponses,
  type TransparencyProposalsSecClassificationCodesRetrieveData,
  type TransparencyProposalsSecClassificationCodesRetrieveResponse,
  type TransparencyProposalsSecClassificationCodesRetrieveResponses,
  type TransparencyPublicSecurityIdsSearchCreateData,
  type TransparencyPublicSecurityIdsSearchCreateResponse,
  type TransparencyPublicSecurityIdsSearchCreateResponses,
  type TriggerComputeEntitlementsRequest,
  type TriggerProcessMeetingBallotsRequest,
  type UnassociatedInstrumentsResponse,
  type UnassociatedInstrumentsResponseWritable,
  UpdateMaskEnum,
  type UpdateVotingRecommendationFromPvrRequest,
  type UpsertPiProposalCategoryRequest,
  type UpsertPiProposalCategoryResponse,
  type UpsertRequestRequest,
  type UpsertResponse,
  UpsertStatusEnum,
  type User,
  type UserSearchRequestRequest,
  type UserWriteRequest,
  ValidationStatusEnum,
  ValidEnum,
  VoteMethodEnum,
  type VoterDetailsResponse,
  type VoterResponse,
  type VoterResponseWritable,
  VoterTypeEnum,
  type VoterWithHoldingsInputRequest,
  type VoterWithHoldingsResponse,
  type VoterWithHoldingsResponseWritable,
  type VoteStatus,
  type VoteStatusDeleteRequestRequest,
  type VoteStatusHardDeleteRequestRequest,
  type VoteStatusHardDeleteResponse,
  type VoteStatusUpsertRequestRequest,
  type VoteStatusUpsertResponse,
  VoteStatusUpsertStatusEnum,
  VotingInstructionEnum,
  type VotingOperationsPiballotsFilterListData,
  type VotingOperationsPiballotsFilterListResponse,
  type VotingOperationsPiballotsFilterListResponses,
  type VotingOperationsPimeetingsFilterListData,
  type VotingOperationsPimeetingsFilterListResponse,
  type VotingOperationsPimeetingsFilterListResponses,
  VotingOptionsEnum,
  type VotingPolicy,
  type VotingPolicyCreateRequest,
  type VotingPolicyDocument,
  type VotingPolicyDocumentWritable,
  type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData,
  type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse,
  type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses,
  type VotingPolicyProposalSetRecommendationCoverageSearchCreateData,
  type VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors,
  type VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse,
  type VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses,
  type VotingPolicyProviderVotingRecommendationsCreateData,
  type VotingPolicyProviderVotingRecommendationsCreateResponse,
  type VotingPolicyProviderVotingRecommendationsCreateResponses,
  type VotingPolicyProviderVotingRecommendationsDestroyData,
  type VotingPolicyProviderVotingRecommendationsDestroyResponse,
  type VotingPolicyProviderVotingRecommendationsDestroyResponses,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  type VotingPolicyProviderVotingRecommendationsMatchCreateData,
  type VotingPolicyProviderVotingRecommendationsMatchCreateResponse,
  type VotingPolicyProviderVotingRecommendationsMatchCreateResponses,
  type VotingPolicyProviderVotingRecommendationsSearchCreateData,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponse,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationsCreateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData,
  type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData,
  type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponse,
  type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses,
  type VotingPolicySearchRequest,
  type VotingPolicyVotingPoliciesCreateData,
  type VotingPolicyVotingPoliciesCreateResponse,
  type VotingPolicyVotingPoliciesCreateResponses,
  type VotingPolicyVotingPoliciesDestroyData,
  type VotingPolicyVotingPoliciesDestroyResponse,
  type VotingPolicyVotingPoliciesDestroyResponses,
  type VotingPolicyVotingPoliciesDocumentsCreateData,
  type VotingPolicyVotingPoliciesDocumentsCreateResponse,
  type VotingPolicyVotingPoliciesDocumentsCreateResponses,
  type VotingPolicyVotingPoliciesDocumentsListData,
  type VotingPolicyVotingPoliciesDocumentsListResponse,
  type VotingPolicyVotingPoliciesDocumentsListResponses,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesDocumentsRetrieveData,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponse,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  type VotingPolicyVotingPoliciesPartialUpdateData,
  type VotingPolicyVotingPoliciesPartialUpdateResponse,
  type VotingPolicyVotingPoliciesPartialUpdateResponses,
  type VotingPolicyVotingPoliciesRetrieveData,
  type VotingPolicyVotingPoliciesRetrieveResponse,
  type VotingPolicyVotingPoliciesRetrieveResponses,
  type VotingPolicyVotingPoliciesSearchCreateData,
  type VotingPolicyVotingPoliciesSearchCreateResponse,
  type VotingPolicyVotingPoliciesSearchCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
  type VotingPolicyWritable,
  type VotingRecommendation,
  type VotingRecommendationConfidenceScore,
  type VotingRecommendationConfidenceScoreUpsertRequest,
  type VotingRecommendationCreateRequest,
  type VotingRecommendationSearchRequest,
  type VotingRecommendationWritable,
} from './types.gen'
